module.exports = __webpack_public_path__ + "img/logo.c1c8464e.svg";